export class CodeComponentPropUsage {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.usages = model.usages;
        this.values = model.values;
        this.undefinedValue = model.undefinedValue;
    }
}
